<main class="c-main">
  <div class="container-fluid">
    <div class="mat-elevation-z8">
      <mat-card>
        <div class="wow-form-header">
          <div class="wow-form-header__icon"><mat-icon>badge</mat-icon></div>
          <mat-card-title>
            Colaborador
            <span *ngIf="formulario?.value?.id"> — ID {{ formulario.value.id }}</span>
          </mat-card-title>
        </div>

        <p *ngIf="carregando">Carregando...</p>

        <mat-card *ngIf="formulario && !carregando">
          <form [formGroup]="formulario" (ngSubmit)="submit()">
            <div class="row">
            <div class="col-12 col-md-1">
              <mat-form-field appearance="fill" class="full-width">
                <mat-label>ID</mat-label>
                <input matInput formControlName="id" readonly>
              </mat-form-field>
            </div>
            <div class="col-12 col-md-5">
              <mat-form-field appearance="fill" class="full-width">
                <mat-label>Nome</mat-label>
                <input matInput formControlName="nome" required>
              </mat-form-field>
            </div>
            <div class="col-12 col-md-3">
              <mat-form-field appearance="fill" class="full-width">
                <mat-label>CPF</mat-label>
                <input matInput formControlName="cpf" mask="000.000.000-00" [validation]="false">
              </mat-form-field>
            </div>
            <div class="col-12 col-md-3">
              <mat-form-field appearance="fill" class="full-width">
                <mat-label>RG</mat-label>
                <input matInput formControlName="rg">
              </mat-form-field>
            </div>
            <div class="col-12 col-md-3">
              <mat-form-field appearance="fill" class="full-width">
                <mat-label>Telefone</mat-label>
                <input matInput formControlName="telefone" mask="(00) 00000-0000" [validation]="false">
              </mat-form-field>
            </div>
            <div class="col-12 col-md-5">
              <mat-form-field appearance="fill" class="full-width">
                <mat-label>E-mail</mat-label>
                <input matInput formControlName="email" type="email">
              </mat-form-field>
            </div>
            <div class="col-12 col-md-2">
              <mat-form-field appearance="fill" class="full-width">
                <mat-label>Situação</mat-label>
                <mat-select formControlName="ativo">
                  <mat-option [value]="true">Ativo</mat-option>
                  <mat-option [value]="false">Inativo</mat-option>
                </mat-select>
              </mat-form-field>
            </div>
            <div class="col-12 col-md-2">
              <mat-form-field appearance="fill" class="full-width">
                <mat-label>Nascimento</mat-label>
                <input matInput [matDatepicker]="pickerNasc" formControlName="dataNascimento">
                <mat-datepicker-toggle matSuffix [for]="pickerNasc"></mat-datepicker-toggle>
                <mat-datepicker #pickerNasc></mat-datepicker>
              </mat-form-field>
            </div>
            <div class="col-12 col-md-2">
              <mat-form-field appearance="fill" class="full-width">
                <mat-label>Admissão</mat-label>
                <input matInput [matDatepicker]="pickerAdmissao" formControlName="dataAdmissao">
                <mat-datepicker-toggle matSuffix [for]="pickerAdmissao"></mat-datepicker-toggle>
                <mat-datepicker #pickerAdmissao></mat-datepicker>
              </mat-form-field>
            </div>
            <div class="col-12 col-md-2">
              <mat-form-field appearance="fill" class="full-width">
                <mat-label>Demissão</mat-label>
                <input matInput [matDatepicker]="pickerDemissao" formControlName="dataDemissao">
                <mat-datepicker-toggle matSuffix [for]="pickerDemissao"></mat-datepicker-toggle>
                <mat-datepicker #pickerDemissao></mat-datepicker>
              </mat-form-field>
            </div>
            <div class="col-12 col-md-3">
              <mat-form-field appearance="fill" class="full-width">
                <mat-label>Departamento</mat-label>
                <mat-select formControlName="departamentoId" required>
                  <mat-option *ngFor="let d of departamentos" [value]="d.id">{{ d.nome }}</mat-option>
                </mat-select>
              </mat-form-field>
            </div>
            <div class="col-12 col-md-3">
              <mat-form-field appearance="fill" class="full-width">
                <mat-label>Cargo</mat-label>
                <mat-select formControlName="cargoId" required>
                  <mat-option *ngFor="let c of cargos" [value]="c.id">{{ c.nome }}</mat-option>
                </mat-select>
              </mat-form-field>
            </div>
            <div class="col-12">
              <mat-form-field appearance="fill" class="full-width">
                <mat-label>Observação</mat-label>
                <textarea matInput formControlName="observacao" rows="2"></textarea>
              </mat-form-field>
            </div>
          </div>

          <div class="wow-form-acoes">
            <button type="button" mat-stroked-button (click)="voltarConsulta()">
              <mat-icon>arrow_back</mat-icon> Voltar
            </button>
            <button type="button" mat-stroked-button (click)="limpar()">
              <mat-icon>clear</mat-icon> Limpar
            </button>
            <button type="submit" mat-raised-button color="primary" [disabled]="formulario.invalid || salvando">
              <mat-icon>save</mat-icon> Salvar
            </button>
          </div>
        </form>

        <!-- Documentos -->
        <div class="doc-section" *ngIf="formulario && !carregando">
          <div class="doc-section__header">
            <h3><mat-icon>folder</mat-icon> Documentos</h3>
            <button type="button" mat-stroked-button color="primary"
                    (click)="selecionarArquivo(fileInput)" [disabled]="!colaboradorId || enviandoDocumento">
              <mat-icon>upload_file</mat-icon>
              {{ enviandoDocumento ? 'Enviando...' : 'Anexar documento' }}
            </button>
            <input #fileInput type="file" hidden accept="image/*,application/pdf"
                   (change)="onArquivoSelecionado($event)">
          </div>

          <p class="doc-section__hint" *ngIf="!colaboradorId">
            Salve o colaborador para habilitar o anexo de documentos.
          </p>
          <p class="doc-section__hint" *ngIf="colaboradorId && documentos.length === 0">
            Nenhum documento anexado.
          </p>

          <div class="doc-grid" *ngIf="documentos.length">
            <div class="doc-card" *ngFor="let doc of documentos">
              <div class="doc-card__icon">
                <mat-icon *ngIf="ehImagem(doc)">image</mat-icon>
                <mat-icon *ngIf="!ehImagem(doc)">description</mat-icon>
              </div>
              <div class="doc-card__info">
                <span class="doc-card__name" [title]="doc.nome">{{ doc.nome }}</span>
                <span class="doc-card__meta">{{ formatarTamanho(doc.tamanho) }} · {{ doc.dataUpload }}</span>
              </div>
              <div class="doc-card__acoes">
                <button type="button" mat-icon-button color="primary" (click)="baixarDocumento(doc)" matTooltip="Visualizar / baixar">
                  <mat-icon>visibility</mat-icon>
                </button>
                <button type="button" mat-icon-button color="warn" (click)="removerDocumento(doc)" matTooltip="Remover">
                  <mat-icon>delete</mat-icon>
                </button>
              </div>
            </div>
          </div>
        </div>
        </mat-card>
      </mat-card>
    </div>
  </div>
</main>
